/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { Row, Col } from "components/Grid";
import { Label, SelectField } from "components/Form";
import Layout from "components/Layout/index";
import StepNavigation from "components/StepNavigation";
import ClaimsSummary from 'components/ClaimsSummary';
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import FileModal from "components/FileModal";
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import DialogComponent, { DialogConfirm, DialogRejected, ContentTextArea, TextArea2 } from 'components/Dialog';
import FilesAttachment from "components/FilesAttachment";
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { InputField } from "components/Form/index";
import { Text, Line, ButtonContent, AttachmentContainer } from "./styles";
import RenderButtons from 'components/RenderButtons';
import HasPermission from "components/HasPermission/index";
import { useHeaderNbi } from 'services/QuoteService';
import { usePaymentPackHtmlModal, usePaymentConfigurationForm, useGetAttachmentsPaymentPack, usePaymentPackListDirectors } from 'services/PaymentPackService';
import TagsList3 from "components/TagList3";
export default function ApprovalInvoice(props) {
  const [file, setFile] = useState();
  const [summary, setSummary] = useState({});
  const [userComments, setUserComments] = useState(null);
  const authContext = useContext(GlobalAuthContext);
  const [canApprove, setCanApprove] = useState(false);
  const [isDenied, setIsDenied] = useState(false);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [statusEndorsement, setStatusEndorsement] = useState({
    title: "Payment Pack",
    route: "",
  });
  const [directorsList, setDirectorsList] = useState(null);
  const [loggedPerson, setLoggedPerson] = useState({});
  const [canSendDocs, setCanSendDocs] = useState(null);
  const [historymsg, setHistorymsg] = useState([]);
  const [isClaims, setIsClaims] = useState(false);
  const [attachmentsUploaded, setAttachmentsUploaded] = useState([]);
  const [isDirectorLogged, setIsDirectorLogged] = useState(false);
  const [optionApprovalDirector, setOptionApprovalDirector] = useState(false);


  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: usePaymentPackHtmlModalData,
    loading: usePaymentPackHtmlModalLoading,
    error: usePaymentPackHtmlModalError,
    status: usePaymentPackHtmlModalStatus,
    request: usePaymentPackHtmlModalRequest,
  } = usePaymentPackHtmlModal(props.match.params.idOperation);

  const {
    data: usePaymentConfigurationFormData,
    loading: usePaymentConfigurationFormLoading,
    error: usePaymentConfigurationFormError,
    status: usePaymentConfigurationFormStatus,
    request: usePaymentConfigurationFormRequest,
  } = usePaymentConfigurationForm(props.match.params.idOperation);

  const {
    data: useGetAttachmentsPaymentPackData,
    loading: useGetAttachmentsPaymentPackLoading,
    error: useGetAttachmentsPaymentPackError,
    status: useGetAttachmentsPaymentPackStatus,
    request: useGetAttachmentsPaymentPackRequest,
  } = useGetAttachmentsPaymentPack(props.match.params.idOperation);

  const {
    data: usePaymentPackListDirectorsData,
    loading: usePaymentPackListDirectorsLoading,
    error: usePaymentPackListDirectorsError,
    status: usePaymentPackListDirectorsStatus,
    request: usePaymentPackListDirectorsRequest,
  } = usePaymentPackListDirectors(props.match.params.idOperation);


  useEffect(() => {
    if (useHeaderNbiLoading || usePaymentPackHtmlModalLoading || usePaymentConfigurationFormLoading || useGetAttachmentsPaymentPackLoading || usePaymentPackListDirectorsLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, usePaymentPackHtmlModalLoading, usePaymentConfigurationFormLoading, useGetAttachmentsPaymentPackLoading, usePaymentPackListDirectorsLoading]);

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
            ${message.approvalComments}
      
              `;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }
  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          isFramework: data.ret_value.isFramework,
          idOperation: props.match.params.idOperation,
        });

        if (data.ret_value.paymentPackMessage) {
          if (formik.current) {
            formik.current?.setFieldValue('paymentPackMessage', data.ret_value.paymentPackMessage);
          }
        }

        setHistorymsg(data.ret_value.historical);
        setEndorsmentType(data.ret_value.endorsmentType)
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
      });
  };

  function handleGetAttachments() {
    useGetAttachmentsPaymentPackRequest().then(({data}) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        setAttachmentsUploaded(data.ret_value)
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetAttachments.name}\n` + error);
      });
  };

  function handleFile() {
    usePaymentPackHtmlModalRequest().then(({data: resp}) => {
        if (resp.ret_code === 200) {
          setFile(resp.ret_value.paymentPackDocs.filter((paymentFile) => paymentFile.idDomain !== 367 ))
          setCanApprove(resp.ret_value.canApprove)
          setIsDenied(resp.ret_value.isDenied)
        } else {
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
      });
  };

  function handleListDirectors() {
    setLoggedPerson(authContext.login_response.ret_value);
    usePaymentPackListDirectorsRequest().then(({data: resp}) => {
        if (resp.ret_code === 200) {
          const directors = resp.ret_value.sort((a,b) => String(a?.name).localeCompare(String(b?.name)));
          const isDirectorLogged = directors && directors.find(director => director.idPerson === authContext.login_response?.ret_value?.idPerson);
          const optionApproval = isDirectorLogged?.optionApproval === "Sent";

          setOptionApprovalDirector(optionApproval)
          setDirectorsList(directors);
          setIsDirectorLogged(isDirectorLogged)
        } else {
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data:${handleListDirectors.name} \n` + error);
      });
  }

  const [typeDialog, setTypeDialog] = useState(null);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });

  function handleCancel() {
    setUserComments("");
    setDialog({
      visible: false,
      title: '',
      icon: 'exclamation',
      args: null
    })
  }

  function handleDialog(type) {
    if (type === "approve") {
      setTypeDialog("approve");
      setDialog({
        visible: true,
        title: "APPROVE PAYMENT PACK Request",
        icon: "TimesCircle",
        args: null,
      })
    } else if (type === 'rejected') {
      setTypeDialog("rejected");
      setDialog({
        visible: true,
        title: "REJECT PAYMENT PACK REQUEST",
        icon: "TimesCircle",
        args: null,
      })
    } else {
      setDialog({
        visible: false,
        title: "",
        icon: "",
        args: null,
      })
    }
  };

  function handleApproval() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.paymentPackApprove(props.match.params.idOperation, userComments)
      .then(response => response.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          setCanSendDocs(resp.ret_value.canSendDocs);
          loading.stop();
          isClaims ? history.push('/claims') : history.push('/policies');
        } else {
          loading.stop();
          mc.error(resp.ret_msg_details);
        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleApproval.name}\n` + error);
      })
  };

  function handleReject() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.paymentPackReject(props.match.params.idOperation, userComments)
      .then(x => x.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          loading.stop();
          mc.success("Approval Payment Pack Rejected");
          isClaims ? history.push('/claims') : history.push('/policies');
        } else {
          loading.stop();
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleReject.name}\n` + error);
      });
  };


  function getPaymentConfigurationForm() {
    usePaymentConfigurationFormRequest().then(({data: response}) => {
        if (response.ret_code != 200) {
          mc.error(response.ret_msg_details);
          history.goBack();
          return;
        }

        setIsClaims(response.ret_value.isClaims);
        const settlementDateAnswer = response.ret_value?.paymentConfigurationQuestions?.find(x => x.dsQuestion == 'Settlement Date')?.answer
        const paymentDateAnswer = response.ret_value?.paymentConfigurationQuestions?.find(x => x.dsQuestion == 'Payment Date')?.answer

        if (formik.current) {
          formik.current?.setFieldValue('settlementDate', settlementDateAnswer)
          formik.current?.setFieldValue('paymentDate', paymentDateAnswer)
        }

      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${getPaymentConfigurationForm.name}\n` + error);
      });
  }

  const goToLoginPage = () => {
    history.push('login');
  };

  useEffect(() => {
    let v = handleHistoryMessage()
    if (formik.current) {
      formik.current?.setFieldValue('dealAnalisysInformation', v)
    }
  }, [historymsg])

  useEffect(() => {
    handleListDirectors();
    getStatus(directorsList);
  }, [canSendDocs]);

  useEffect(() => {
    getStatus(directorsList);
  }, [directorsList])

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);
     
    handleGetAttachments();
    getPaymentConfigurationForm();
    handleFile();
    handleSummary();
    handleListDirectors();
  }, []);

  useEffect(() => {
    if (endorsmentType === 'pre-agreed') {
      setStatusEndorsement({
        title: "ENDORSEMENT - ANNIVERSARY: PREMIUM PRE AGREED / APPROVAL",
        route: ''
      })
    } else if (endorsmentType === 'not-pre-agreed') {
      setStatusEndorsement({
        title: "ENDORSEMENT - ANNIVERSARY: PREMIUM NOT PRE AGREED / APPROVAL",
        route: ''
      })
    } else if (endorsmentType === 'off-risk') {
      return;
    } else if (endorsmentType === 'cancellation') {
      setStatusEndorsement({
        title: "ENDORSEMENT - CANCELLATION / APPROVAL",
        route: ''
      })
    }
    else if (endorsmentType === 'market-changes') {
      setStatusEndorsement({
        title: "RISK & MARKET CHANGES / APPROVAL",
        route: ''
      })
    }
  }, [endorsmentType])

  function handleMktCompostion() {
    history.push(`/broking/market-composition/${props.match.params.idOperation}`)
  };

  function handlePaymentConfiguration() {
    history.push(`/broking/payment-pack-configuration/${props.match.params.idOperation}`)
  };

  function handleSendPaymentPack() {
    history.push(`/broking/payment-pack-send-client-insurer/${props.match.params.idOperation}`);
  }

  const columns = [
    {
      title: "Director",
      value: "directorName",
      col: 4,
      style: ''
    },
    {
      title: "Comments",
      value: "comments",
      col: 4,
      style: ''
    },
    {
      title: "Status",
      value: "status",
      col: 4,
      style: ''
    },
  ];

  const options = [
    {
      label: "SENT",
      value: "Sent",
    },
    {
      label: "APPROVED",
      value: "approve"
    },
    {
      label: "DECLINED",
      value: "rejected"
    }
  ];

  function getStatus(directors) {
    if (directors) {
      directors.map((director, index) => {
        if (formik.current) {
          formik.current?.setFieldValue(`statusPaymentPack${index}`, director.optionApproval);
        }
      })
    }
  }

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}>
      {isClaims ? <ClaimsSummary stage={3} idOperation={props.match?.params?.idOperation} />
        : <>
          <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
          <BrokingSummary data={summary} />
          </>
      }
      <ContentCard
        title={statusEndorsement.title}
        icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>

        <DialogComponent icon={dialog.icon} title={dialog.title}  show={dialog.visible} setDialog={setDialog}>
          {typeDialog === 'approve' ?
            <ContentTextArea>
              <p>Deal Analysis information</p>
              <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
              <DialogRejected onClick={() => handleCancel()}>CANCEL</DialogRejected>
              <DialogConfirm onClick={() => handleApproval()}>CONFIRM</DialogConfirm>
            </ContentTextArea>

            : typeDialog === 'rejected' ?
              <ContentTextArea>
                <p>Deal Analysis information</p>
                <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
                <DialogRejected type="submit" onClick={() => handleCancel()}>CANCEL</DialogRejected>
                <DialogConfirm type="submit" onClick={() => handleReject()}>CONFIRM</DialogConfirm>
              </ContentTextArea>
              : ""
          }
        </DialogComponent>


        <Formik
          innerRef={formik}
          initialValues={{
            paymentPackMessage: 'Loading...',
            dealAnalisysInformation: '',
            statusPaymentPack: ''
          }}
          onSubmit={''}
        >

          {formikProps => (
            <Form>
              {!summary.isFramework && <Row>
                <Col>
                  <Field
                    readOnly
                    label={'Message - (Internal)'}
                    name={'paymentPackMessage'}
                    value={formikProps.values.paymentPackMessage}
                    onChange={(e) => formikProps?.setFieldValue('paymentPackMessage', e)}
                    component={TextField}
                  />
                </Col>
              </Row>}
              <Row>
                {formikProps.values.paymentDate &&
                  <Col md={3}>
                    <Field
                      disabled
                      name="paymentDate"
                      label="Payment Date"
                      placeholder="Payment Date"
                      type="text"
                      rightIcon="calendar"
                      rightIconClick={() => { }}
                      component={InputField}
                      value={formikProps.values.paymentDate}
                      onChange={() => { }}
                      canGenerate={false}
                    />
                  </Col>
                }

                {formikProps.values.settlementDate &&
                  <Col md={3}>
                    <Field
                      disabled
                      name="settlementDate"
                      label="Settlement Date"
                      placeholder="Settlement Date"
                      type="text"
                      rightIcon="calendar"
                      rightIconClick={() => { }}
                      component={InputField}
                      value={formikProps.values.settlementDate}
                      onChange={() => { }}
                      canGenerate={false}
                    />
                  </Col>
                }
              </Row>

              <FileModal idOperation={props?.match?.params?.idOperation} file={file} />

              { attachmentsUploaded && (
                  <Col md={12} sm={1} style={{ marginBottom: 20 }}>
                    <Label>Attachment(s)</Label>
                    <TagsList3
                        tags={attachmentsUploaded.filter(file => file.nameFile)}
                        disableType
                        hideTrash={true}
                    />
                  </Col>
              )}

              <FilesAttachment signedDocs idOperation={props.match.params.idOperation} />

              <div style={{ margin: '80px auto 15px', width: '98%' }}>
                <span>
                  <Row>
                    {canApprove && columns && columns.map((column, index) => {
                      return (
                        <Col sm={column.col} key={index} className={'d-none d-md-block pl-0 ' + column.style}>
                          <Text>
                            {column.title}
                          </Text>
                        </Col>
                      )
                    })}
                  </Row>
                </span>
                {canApprove && directorsList && directorsList.map((director, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Row style={{ marginTop: '5px' }}>
                        <Col sm={4} md={4} className="pl-0">
                          <Label textColor={Colors.GRAY[0]}>
                            {director.name}
                          </Label>
                        </Col>
                        <Col sm={4} md={4} className="pl-0">
                          <Label textColor={Colors.GRAY[0]}>
                            {director.comments}
                          </Label>
                        </Col>

                        <Col sm={4} md={4} className="pl-0">
                          <Field
                            key={index}
                            name={`statusPaymentPack${index}`}
                            component={SelectField}
                            options={options}
                            validation={false}
                            weight="400"
                            value={formikProps.values.statusPaymentPack[index]}
                            disabled={director.optionApproval !== 'Sent' || director.idPerson !== loggedPerson?.idPerson}
                            onChange={(e) => {
                              formikProps?.setFieldValue(`statusPaymentPack${index}`, e);
                              handleDialog(e)
                            }
                            }
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col className="pl-2 pr-2">
                          <Line style={{ display: index === directorsList.length - 1 ? 'none' : null }} />
                        </Col>
                      </Row>
                    </React.Fragment>
                  )
                })}
              </div>
              <Field
                readOnly
                label={'Deal Analysis Information'}
                name={'dealAnalisysInformation'}
                value={formikProps.values.dealAnalisysInformation}
                onChange={(e) => formikProps?.setFieldValue('dealAnalisysInformation', e)}
                component={TextField}
              />

              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                <RenderButtons idOperation={props.match?.params?.idOperation}>
                  <ButtonContent>
                    <HasPermission permission={!isDenied && canApprove && props.permissions.PAYMENT_PACK_CREATE}>
                      <Button
                        third
                        type="submit"
                        id="btnReject"
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handlePaymentConfiguration() }}
                      >
                        UPDATE PAYMENT PACK
                      </Button>
                    </HasPermission>
                    <HasPermission permission={false}>
                      <Button
                        third
                        type="submit"
                        id="btnReject"
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        disabled={isDirectorLogged && optionApprovalDirector ? false : true}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog('rejected')}}
                        
                      >
                        REJECT PAYMENT PACK
                      </Button>
                    </HasPermission>
                    <HasPermission permission={false}>
                      <Button
                        primary
                        type="submit"
                        id="btnApprove"
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        disabled={isDirectorLogged && optionApprovalDirector ? false : true}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog('approve')}}
                      >
                        APPROVE PAYMENT PACK
                      </Button>
                    </HasPermission>
                    <HasPermission permission={isDenied && !endorsmentType && props.permissions.MARKETING_COMPOSITION}>
                      <Button
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        third
                        id="btnSubmitMktComposition" 
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleMktCompostion() }}
                      >
                       CDR 
                      </Button>
                    </HasPermission>

                    <HasPermission permission={isDenied && props.permissions.PAYMENT_PACK_CREATE}>

                      <Button
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        primary
                        type="submit"
                        id="btnSubmitPaymentConfiguration"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handlePaymentConfiguration() }}
                      >
                        REGENERATE PAYMENT DOCS
                      </Button>
                    </HasPermission>
                  </ButtonContent>
                </RenderButtons>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
} 
